import { Link } from 'react-router-dom';
import './HomeScreen.scss';

const CONTACT = {
  phone: '1544-0000',
  email: 'support@cafeappmoa.co.kr',
};

// 히어로 영역의 "매장마다 다른 브랜드 앱" 예시. 실제 입점 매장이 아닌 데모 데이터다.
const SAMPLE_APPS = [
  { name: '모닝브루', tagline: '아침을 여는 한 잔', color: '#2f6b4f', stamps: 7 },
  { name: '라떼하우스', tagline: '부드러운 오후의 시작', color: '#b5653a', stamps: 4 },
  { name: '블루밍 로스터스', tagline: '오늘 볶은 원두', color: '#2f4f8a', stamps: 9 },
];

const PAINS = [
  {
    who: '사장님',
    icon: 'storefront',
    items: [
      '전용 앱을 만들고 유지할 예산과 인력이 부족해요',
      '배달 중개 앱은 수수료 부담이 크고 매장 감성을 담기 어려워요',
      '종이 스탬프는 분실이 잦고 단골 관리가 어려워요',
      '출근·점심 피크타임 현장 대기로 손님이 돌아가요',
    ],
  },
  {
    who: '손님',
    icon: 'person',
    items: [
      '개인 카페에는 사이렌오더 같은 사전 주문이 없어요',
      '매장마다 종이 쿠폰을 따로 챙겨 다녀야 해요',
    ],
  },
];

const FEATURES = [
  {
    icon: 'palette',
    title: '우리 카페 전용 브랜드 앱',
    desc: '로고, 대표 색상, 메인 배너, 소개글을 등록하면 고객 앱 디자인에 즉시 반영돼요. 다른 카페의 정보나 광고는 노출되지 않아요.',
  },
  {
    icon: 'notifications_active',
    title: '실시간 주문 접수',
    desc: '결제와 동시에 태블릿·POS로 알림음과 팝업이 떠요. 예상 제조시간(5분·10분)을 골라 승인하거나 사유와 함께 거절할 수 있어요.',
  },
  {
    icon: 'restaurant_menu',
    title: '메뉴 · 품절 관리',
    desc: '메뉴, 가격, 옵션 그룹을 등록하고 메뉴·옵션별 품절을 토글 한 번으로 고객 앱에 바로 반영해요.',
  },
  {
    icon: 'local_cafe',
    title: '매장 전용 스탬프 · 쿠폰',
    desc: '픽업 알림과 동시에 스탬프가 자동 적립돼요. 매장별로 독립 운영되어 단골 고객 관리에 집중할 수 있어요.',
  },
  {
    icon: 'credit_card',
    title: '간편 결제 · 자동 환불',
    desc: '카카오페이 · 네이버페이로 결제하고, 주문 거절이나 미응답 시에는 결제가 자동으로 전액 취소돼요.',
  },
  {
    icon: 'insights',
    title: '매출 통계',
    desc: '일별 · 월별 매출과 메뉴별 판매 현황을 그래프로 확인하며 매장 운영 지표를 한눈에 파악해요.',
  },
];

const FLOW_STEPS = [
  { label: '접수 대기', desc: '손님 결제 완료 → 1초 안에 매장 화면에 알림' },
  { label: '주문 승인', desc: '사장님이 예상 소요시간 선택 → 손님에게 푸시' },
  { label: '제조 중', desc: '주문 진행 상황을 손님 앱에서 실시간 확인' },
  { label: '픽업 요청', desc: '[픽업 알림] 클릭 → 푸시 발송 · 스탬프 자동 적립' },
  { label: '수령 완료', desc: '거래 완료 처리' },
];

const SAFEGUARDS = [
  { icon: 'timer_off', title: '5분 미응답 자동 취소', desc: '놓친 주문은 자동 환불되고, 매장 화면에 미확인 취소 건으로 표시돼요.' },
  { icon: 'do_not_disturb_on', title: '영업 외 시간 주문 차단', desc: '영업 마감 시 손님 앱의 주문 버튼이 비활성화돼요.' },
  { icon: 'wifi_off', title: '불안정한 Wi-Fi 대비', desc: '실시간 연결이 끊기면 주기적 확인(폴링)으로 신규 주문을 놓치지 않아요.' },
];

const JOIN_STEPS = [
  { icon: 'support_agent', title: '입점 문의', desc: '전화나 이메일로 매장 정보를 알려주세요.' },
  { icon: 'how_to_reg', title: '매장 등록', desc: '카페앱모아가 매장과 점주 계정을 만들어 드려요.' },
  { icon: 'brush', title: '브랜딩 · 메뉴 설정', desc: '로고, 색상, 메뉴를 등록해 우리 카페만의 앱을 꾸며요.' },
  { icon: 'rocket_launch', title: '앱 오픈', desc: '손님에게 앱을 안내하고 스마트 오더를 시작해요.' },
];

function Icon({ name, size }: { name: string; size?: number }) {
  return (
    <span className="material-icons" style={size ? { fontSize: size } : undefined} aria-hidden>
      {name}
    </span>
  );
}

function HomeScreen() {
  return (
    <div className="HomeScreen">
      {/* ── Hero ─────────────────────────────────────────── */}
      <section className="HomeScreen-hero">
        <div className="inner HomeScreen-heroInner">
          <div className="HomeScreen-heroText">
            <p className="HomeScreen-eyebrow">SMART ORDER PLATFORM FOR CAFES</p>
            <h1>
              우리 카페만의 앱,
              <br />
              <span>카페앱모아</span>로 시작하세요
            </h1>
            <p className="HomeScreen-lead">
              개인 카페도 프랜차이즈처럼. 매장 로고와 색상을 담은 전용 앱으로
              <br className="HomeScreen-brDesktop" />
              사전 주문 · 간편 결제 · 스탬프 적립까지 한 번에 운영하세요.
            </p>

            <div className="HomeScreen-heroActions">
              <a href="#contact" className="HomeScreen-btn">입점 문의하기</a>
              <Link to="/appmanage/login" className="HomeScreen-btn is-ghost">점주 로그인</Link>
            </div>
          </div>

          <div className="HomeScreen-heroVisual" aria-hidden>
            {SAMPLE_APPS.map((app, i) => (
              <div key={app.name} className={`HomeScreen-phone is-${i}`} style={{ ['--tenant' as string]: app.color }}>
                <div className="HomeScreen-phoneHead">
                  <span className="HomeScreen-phoneLogo">
                    <Icon name="local_cafe" size={16} />
                  </span>
                  <strong>{app.name}</strong>
                </div>
                <div className="HomeScreen-phoneBanner">
                  <span>{app.tagline}</span>
                </div>
                <div className="HomeScreen-phoneStamps">
                  {Array.from({ length: 10 }).map((_, s) => (
                    <i key={s} className={s < app.stamps ? 'is-on' : ''} />
                  ))}
                </div>
                <span className="HomeScreen-phoneBtn">주문하기</span>
              </div>
            ))}
            <p className="HomeScreen-heroCaption">매장마다 다른 브랜드 앱 · 예시 화면</p>
          </div>
        </div>
      </section>

      {/* ── 서비스 소개 ──────────────────────────────────── */}
      <section id="about" className="HomeScreen-section">
        <div className="inner">
          <SectionHead
            eyebrow="WHY CAFEAPPMORE"
            title="개인 카페의 고민, 카페앱모아가 해결해요"
            desc="한 번의 입점으로 매장마다 독립된 브랜드 앱과 점주용 관리 화면을 함께 제공해요."
          />

          <div className="HomeScreen-pains">
            {PAINS.map((pain) => (
              <div key={pain.who} className="HomeScreen-pain">
                <div className="HomeScreen-painHead">
                  <span className="HomeScreen-iconBadge"><Icon name={pain.icon} /></span>
                  <strong>{pain.who}의 고민</strong>
                </div>
                <ul>
                  {pain.items.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="HomeScreen-goals">
            <div>
              <Icon name="storefront" />
              <p>
                <strong>사장님에게</strong> 매장 고유의 브랜딩이 적용된 전용 앱과 저비용 스마트 오더 환경을
              </p>
            </div>
            <div>
              <Icon name="favorite" />
              <p>
                <strong>손님에게</strong> 대기 없는 주문과 매장 전용 디지털 스탬프 · 쿠폰을
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ── 주요 기능 ────────────────────────────────────── */}
      <section id="features" className="HomeScreen-section is-tinted">
        <div className="inner">
          <SectionHead
            eyebrow="FEATURES"
            title="카페 운영에 필요한 모든 것"
            desc="손님용 브랜드 앱부터 점주용 주문 접수 · 메뉴 · 통계 관리까지 하나로 연결돼요."
          />

          <div className="HomeScreen-featureGrid">
            {FEATURES.map((feature) => (
              <div key={feature.title} className="HomeScreen-featureCard">
                <span className="HomeScreen-iconBadge"><Icon name={feature.icon} /></span>
                <h3>{feature.title}</h3>
                <p>{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── 주문 흐름 ────────────────────────────────────── */}
      <section id="flow" className="HomeScreen-section">
        <div className="inner">
          <SectionHead
            eyebrow="ORDER FLOW"
            title="사이렌오더 방식의 실시간 주문 흐름"
            desc="손님 결제부터 픽업까지 모든 단계가 매장 화면과 손님 앱에 실시간으로 동기화돼요."
          />

          <ol className="HomeScreen-track">
            {FLOW_STEPS.map((step, i) => (
              <li key={step.label}>
                <span className="HomeScreen-trackNode">{i + 1}</span>
                <strong>{step.label}</strong>
                <span>{step.desc}</span>
              </li>
            ))}
          </ol>

          <div className="HomeScreen-safeguards">
            {SAFEGUARDS.map((item) => (
              <div key={item.title} className="HomeScreen-safeguard">
                <Icon name={item.icon} />
                <div>
                  <strong>{item.title}</strong>
                  <p>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── 입점 안내 ────────────────────────────────────── */}
      <section id="join" className="HomeScreen-section is-tinted">
        <div className="inner">
          <SectionHead eyebrow="HOW TO JOIN" title="입점은 이렇게 진행돼요" />

          <ol className="HomeScreen-joinSteps">
            {JOIN_STEPS.map((step, i) => (
              <li key={step.title} className="HomeScreen-joinStep">
                <span className="HomeScreen-iconBadge"><Icon name={step.icon} /></span>
                <span className="HomeScreen-stepNo">STEP {i + 1}</span>
                <strong>{step.title}</strong>
                <p>{step.desc}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>

      {/* ── 문의 ─────────────────────────────────────────── */}
      <section id="contact" className="HomeScreen-contact">
        <div className="inner HomeScreen-contactInner">
          <div>
            <p className="HomeScreen-eyebrow">CONTACT</p>
            <h2>우리 카페 앱, 지금 만들어 보세요</h2>
            <p>입점 상담부터 브랜딩 설정까지 카페앱모아가 함께해요.</p>
          </div>
          <div className="HomeScreen-contactActions">
            <a className="HomeScreen-contactBtn" href={`tel:${CONTACT.phone}`}>
              <Icon name="call" />
              <span>
                <small>고객센터</small>
                <strong>{CONTACT.phone}</strong>
              </span>
            </a>
            <a className="HomeScreen-contactBtn" href={`mailto:${CONTACT.email}`}>
              <Icon name="mail" />
              <span>
                <small>이메일</small>
                <strong>{CONTACT.email}</strong>
              </span>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

function SectionHead({ eyebrow, title, desc }: { eyebrow: string; title: string; desc?: string }) {
  return (
    <div className="HomeScreen-sectionHead">
      <p className="HomeScreen-eyebrow">{eyebrow}</p>
      <h2>{title}</h2>
      {desc ? <p className="HomeScreen-sectionDesc">{desc}</p> : null}
    </div>
  );
}

export default HomeScreen;
